import axios from "../../../config/axiosConfig";

export const listProyectos = () => axios.get("/api/telusgy/proyectos");

export const createProyecto = (formData) =>
  axios.post("/api/telusgy/proyectos", formData);

export const updateProyecto = (id, formData) =>
  axios.put(`/api/telusgy/proyectos/${id}`, formData);

export const deleteProyecto = (id) => axios.delete(`/api/telusgy/proyectos/${id}`);
